<div class="container">
  <nav class="payment-nav d-flex d-lg-none flex-row align-items-center">
    <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
      <label>{{ 'payment.card' | translate }}</label>
    </a>
    <a
      class="nav-item"
      [routerLink]="['/ecashhistory']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <label>{{ 'payment.history' | translate }}</label>
    </a>
  </nav>
</div>
